// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-module__default--2-k9Q{border-radius:2px;cursor:pointer;font-weight:700;font-size:14px;font-family:Arial,Roboto,Helvetica,sans-serif}.button-module__primary--2h_Rh{background-color:#1e54b7}.button-module__primary--2h_Rh:hover{background-color:#102c60}.button-module__secondary--2UdBA{background-color:#f6f6f6;border:1px solid #e2e2e2;color:#212121}.button-module__secondary--2UdBA:hover{background-color:#e2e2e2}.button-module__border--DO-kH{border:1px solid #e2e2e2;background:none;color:#212121}.button-module__border--DO-kH:hover{background-color:#e2e2e2}.button-module__disabled--1oOPB{opacity:.7;pointer-events:none}", ""]);
// Exports
exports.locals = {
	"default": "button-module__default--2-k9Q",
	"primary": "button-module__primary--2h_Rh",
	"secondary": "button-module__secondary--2UdBA",
	"border": "button-module__border--DO-kH",
	"disabled": "button-module__disabled--1oOPB"
};
module.exports = exports;
